/* eslint-disable @typescript-eslint/naming-convention */
import {
  countries,
  countries_ba,
  countries_bg,
  countries_se,
  countries_fi,
  countries_no,
  countries_de,
  countries_be,
  countries_nl,
  countries_hr,
  countries_hu,
  countries_cz,
  countries_ee,
  countries_lv_lt,
  countries_dk_se_fi_no,
  countries_es,
  countries_pt,
  countries_it,
  countries_pl,
  countries_al,
  countries_rs,
  countries_gr,
  countries_ro,
  countries_uk,
  countries_br,
} from "./countries.mock";

export const contact: any[] = [
  {
    lang: {
      country: "ba",
      code: "bs",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ba,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/informacije-o-proizvodu",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ba,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/napomena-o-proizvodu",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Pitanje u vezi sa web stranicom i pristupačnošću weba",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ba,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/pitanje-web-stranica",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "bg",
      code: "bg",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_bg,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakti/informatsiia-za-produkta",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_bg,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakti/belezhka-za-produkta",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Въпрос относно уебсайта и уеб достъпността",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_bg,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakti/vupros-ueb-sayt",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "ua",
      code: "uk",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_uk,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakty/zapyt-pro-produkt",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_uk,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakty/zauvazhennia-shchodo-produktu",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Запитання щодо веб-сайту та його доступності",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_uk,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakty/zapyt-veb-sayt",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "fr",
      code: "fr",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "Salades",
                    value: "2",
                  },
                  {
                    label: "Légumes surgelés",
                    value: "3",
                  },
                  {
                    label: "Conserves",
                    value: "1",
                  },
                  {
                    label: "Traiteur",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              // {
              //   description: "",
              //   sfType: "SfFormImage",
              //   technicalName: "",
              //   required: false,
              //   autocomplete: "off",
              //   width: 50,
              // },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/nous-contacter/renseignement-produit",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "Salades",
                    value: "2",
                  },
                  {
                    label: "Légumes surgelés",
                    value: "3",
                  },
                  {
                    label: "Conserves",
                    value: "1",
                  },
                  {
                    label: "Traiteur",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/nous-contacter/remarque-produit",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.BUSINESS_INFORMATION",
        iconName: "medal",
        formSections: [],
        popup: true,
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "handshake",
        formSections: [],
        link: {
          url: "https://www.bonduelle.com/fr/contact/adresser-une-demande-de-partenariatsponsoring.html",
          is_external: true,
        },
      },
      {
        title: "Vendre vos produits/services à Bonduelle ",
        iconName: "farmer",
        formSections: [],
        link: {
          url: "https://www.bonduelle.com/fr/contact/vendre-vos-produitsservices-a-bonduelle.html",
          is_external: true,
        },
      },
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.fr/contact",
          is_external: true,
        },
      },
      {
        title: "Nous rejoindre",
        iconName: "ambassador",
        formSections: [],
        link: {
          url: "https://jobs.bonduelle.com/?locale=fr_FR",
          is_external: true,
        },
      },
      // {
      //   title: 'Contacter le service export (importateur)',
      //   iconName: 'planet',
      //   formSections: [],
      //   link: {
      //     url: 'https://www.bonduelle.com/fr/contact/contacter-notre-service-export-importateur.html',
      //     is_external: true
      //   }
      // },
      {
        title: "FORM.PRESS_SERVICE",
        iconName: "newspaper",
        formSections: [],
        link: {
          url: "https://www.bonduelle.com/fr/contact/contacter-notre-agence-de-presse-journaliste",
          is_external: true,
        },
      },
      {
        title: "Contacter le service export",
        iconName: "planet",
        formSections: [],
        link: {
          url: "https://www.bonduelle.com/fr/contact/contacter-notre-service-export-importateur",
          is_external: true,
        },
      },
      {
        title: "Question concernant le site web et l'accessibilité web",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/nous-contacter/accessibilite",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "hr",
      code: "hr",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_hr,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/informacije-proizvod",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_hr,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/primijedba-proizvod",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title:
          "Kérdés a weboldallal és a webes akadálymentességgel kapcsolatban",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_hr,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/pitanje-web-stranica",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "de",
      code: "de",
      default: true,
    },
    forms: [
      {
        title: "Frage zu einem Konservenprodukt",
        iconName: "mystery-can",
        formSections: [
          {
            title: "Frage",
            description: "",
            formFields: [
              {
                label: "Name",
                placeholder: "Ihr Name",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "Vorname",
                placeholder: "Ihr Vorname",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "E-Mail Adresse",
                placeholder: "mymail@email.com",
                description: "",
                confirm: "E-Mail Adresse bestätigen",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                errorConfirm: "Bitte bestätigen Sie Ihre E-Mail-Adresse.",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "PLZ",
                placeholder: "PLZ",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Stadt",
                placeholder: "Ort",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefonnummer",
                placeholder: "Ihre Telefonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_de,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "Frage zum Produkt",
            description:
              "Bitte geben Sie die folgenden Informationen ein, damit unsere Dienste Ihre Anfrage bearbeiten können:",
            formFields: [
              {
                label: "Betroffene Produktgruppe",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "Gemüsekonserven",
                    value: "1",
                    default: true,
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Produktname",
                placeholder: "",
                description:
                  "Geben Sie den Namen des Bonduelle-Produkts an, auf das sich Ihre Frage bezieht",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Detaillierte Informationen",
            description:
              "Für die Anfrage können Sie die entsprechenden Felder ausfüllen und ein Foto als Beispiel hinzufügen. Die Fotos müssen deutlich den Barcode, die Chargennummer und das Verfallsdatum des Produkts enthalten.",
            formFields: [
              {
                label: "Barcode des Produkts",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Der Barcode besteht aus \n13 Ziffern auf der\nVerpackung des Produkts.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "Chargennummer des Produkts",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Die Chargennummer beginnt mit einem L \n gefolgt von einer Reihe von Ziffern. \n Sie finden sie auf der Rückseite der Verpackung \n oder am Boden der Dose. \n\nZum Beispiel: L72450492107: 13.",
                // },
              },
              {
                label: "Verfallsdatum",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "Geben Sie das Datum wie folgt ein: TT / MM / JJJJ",
                width: 50,
                // hint: {
                //   description:
                //     "Das Verfallsdatum ist auf der Rückseite\n der Verpackung oder auf dem\nBoden der Dose angegeben.",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "Ihre Nachricht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schreiben Sie Ihre Nachricht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Weiteres Foto",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/frage-produkt",
        },
        seoTitle: "Frage zu einem Produkt | Bonduelle",
        seoDescription:
          "Wenden Sie sich an unseren Verbraucherservice, um Informationen zu einem Produkt aus unserem Sortiment zu erhalten.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Beschwerde zu einem Konservenprodukt",
        iconName: "bell",
        formSections: [
          {
            title: "Frage",
            description: "",
            formFields: [
              {
                label: "Name",
                placeholder: "Ihr Name",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Vorname",
                placeholder: "Ihr Vorname",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "E-Mail Adresse",
                placeholder: "adresse@email.com",
                description: "",
                confirm: "E-Mail Adresse bestätigen",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                errorConfirm: "Bitte bestätigen Sie Ihre E-Mail-Adresse.",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "PLZ",
                placeholder: "PLZ",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Stadt",
                placeholder: "Ort",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefonnummer",
                placeholder: "Ihre Telefonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_de,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Frage zum Produkt",
            description:
              "Bitte geben Sie die folgenden Informationen ein, damit unsere Dienste Ihre Anfrage bearbeiten können:",
            formFields: [
              {
                label: "Betroffene Produktgruppe",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "Gemüsekonserven",
                    value: "1",
                    default: true,
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Produktname",
                placeholder: "",
                description:
                  "Geben Sie den Namen des Bonduelle-Produkts an, auf das sich Ihre Frage bezieht",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Detaillierte Informationen",
            description:
              "Für die Anfrage können Sie die entsprechenden Felder ausfüllen und ein Foto als Beispiel hinzufügen. Die Fotos müssen deutlich den Barcode, die Chargennummer und das Verfallsdatum des Produkts enthalten.",
            formFields: [
              {
                label: "Barcode des Produkts",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Der Barcode besteht aus \n13 Ziffern auf der\nVerpackung des Produkts.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "Chargennummer des Produkts",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Die Chargennummer beginnt mit einem L \n gefolgt von einer Reihe von Ziffern. \n Sie finden sie auf der Rückseite der Verpackung \n oder am Boden der Dose. \n\nZum Beispiel: L72450492107: 13.",
                // },
              },
              {
                label: "Verfallsdatum",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "Geben Sie das Datum wie folgt ein: TT/MM/JJJJ",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Das Verfallsdatum ist auf der Rückseite\nder Verpackung oder auf dem\nBoden der Dose angegeben.",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "Ihre Nachricht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schreiben Sie Ihre Nachricht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Weiteres Foto",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/kommentar-produkt",
        },
        seoTitle:
          "Hinterlassen Sie einen Kommentar zu einem Produkt | Bonduelle",
        seoDescription:
          "Haben Sie einen Hinweis oder Kommentar zu einem Produkt aus unserem Sortiment? Unser Verbraucherservice hilft Ihnen gerne weiter.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title:
          "Bei Fragen oder Beschwerden zu einem Salatprodukt schreiben Sie bitte an </br> kontakt@greenfreshsalads.com",
        iconName: "farmer",
        formSections: [],
        link: {
          url: "mailto:kontakt@greenfreshsalads.com ",
          is_external: true,
        },
      },
      {
        title: "Kontaktiere den Presseservice",
        iconName: "newspaper",
        formSections: [],
        link: {
          url: "/presse",
          is_external: false,
        },
      },
      {
        title: "Sonstige Anfragen",
        iconName: "question-bubble",
        formSections: [
          {
            title: "Frage",
            description: "",
            formFields: [
              {
                label: "Name",
                placeholder: "Ihr Name",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Vorname",
                placeholder: "Ihr Vorname",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "E-Mail Adresse",
                placeholder: "adresse@email.com",
                description: "",
                confirm: "E-Mail Adresse bestätigen",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                errorConfirm: "Bitte bestätigen Sie Ihre E-Mail-Adresse.",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "PLZ",
                placeholder: "PLZ",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Stadt",
                placeholder: "Ort",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefonnummer",
                placeholder: "Ihre Telefonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_de,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "Ihre Nachricht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schreiben Sie Ihre Nachricht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Weiteres Foto",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/sonstige-anfragen",
        },
        seoTitle: "Kontakt für sonstige Anfragen | Bonduelle",
        seoDescription:
          "Kontaktieren Sie unseren Verbraucherservice für Informationen, Service oder Vorschläge.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Frage zur Website und zur Barrierefreiheit",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_de,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/frage-website",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
  },
  {
    lang: {
      country: "at",
      code: "de",
      default: true,
    },
    forms: [
      {
        title: "Frage zu einem Produkt",
        iconName: "mystery-can",
        formSections: [
          {
            title: "Frage",
            description: "",
            formFields: [
              {
                label: "Name",
                placeholder: "Ihr Name",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "Vorname",
                placeholder: "Ihr Vorname",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "E-Mail Adresse",
                placeholder: "mymail@email.com",
                description: "",
                confirm: "E-Mail Adresse bestätigen",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                errorConfirm: "Bitte bestätigen Sie Ihre E-Mail-Adresse.",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "PLZ",
                placeholder: "PLZ",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Stadt",
                placeholder: "Ort",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefonnummer",
                placeholder: "Ihre Telefonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_de,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "Frage zum Produkt",
            description:
              "Bitte geben Sie die folgenden Informationen ein, damit unsere Dienste Ihre Anfrage bearbeiten können:",
            formFields: [
              {
                label: "Betroffene Produktgruppe",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "Gemüsekonserven",
                    value: "1",
                  },
                  {
                    label: "frische Salate",
                    value: "2",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Produktname",
                placeholder: "",
                description:
                  "Geben Sie den Namen des Bonduelle-Produkts an, auf das sich Ihre Frage bezieht",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Detaillierte Informationen",
            description:
              "Für die Anfrage können Sie die entsprechenden Felder ausfüllen und ein Foto als Beispiel hinzufügen. Die Fotos müssen deutlich den Barcode, die Chargennummer und das Verfallsdatum des Produkts enthalten.",
            formFields: [
              {
                label: "Barcode des Produkts",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Der Barcode besteht aus \n13 Ziffern auf der\nVerpackung des Produkts.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "Chargennummer des Produkts",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Die Chargennummer beginnt mit einem L \n gefolgt von einer Reihe von Ziffern. \n Sie finden sie auf der Rückseite der Verpackung \n oder am Boden der Dose. \n\nZum Beispiel: L72450492107: 13.",
                // },
              },
              {
                label: "Verfallsdatum",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "Geben Sie das Datum wie folgt ein: TT / MM / JJJJ",
                width: 50,
                // hint: {
                //   description:
                //     "Das Verfallsdatum ist auf der Rückseite\n der Verpackung oder auf dem\nBoden der Dose angegeben.",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "Ihre Nachricht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schreiben Sie Ihre Nachricht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Weiteres Foto",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/frage-produkt",
        },
        seoTitle: "Frage zu einem Produkt | Bonduelle",
        seoDescription:
          "Wenden Sie sich an unseren Verbraucherservice, um Informationen zu einem Produkt aus unserem Sortiment zu erhalten.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Beschwerde zu einem Produkt",
        iconName: "bell",
        formSections: [
          {
            title: "Frage",
            description: "",
            formFields: [
              {
                label: "Name",
                placeholder: "Ihr Name",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Vorname",
                placeholder: "Ihr Vorname",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "E-Mail Adresse",
                placeholder: "adresse@email.com",
                description: "",
                confirm: "E-Mail Adresse bestätigen",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                errorConfirm: "Bitte bestätigen Sie Ihre E-Mail-Adresse.",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "PLZ",
                placeholder: "PLZ",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Stadt",
                placeholder: "Ort",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefonnummer",
                placeholder: "Ihre Telefonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_de,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Frage zum Produkt",
            description:
              "Bitte geben Sie die folgenden Informationen ein, damit unsere Dienste Ihre Anfrage bearbeiten können:",
            formFields: [
              {
                label: "Betroffene Produktgruppe",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "Gemüsekonserven",
                    value: "1",
                  },
                  {
                    label: "frische Salate",
                    value: "2",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Produktname",
                placeholder: "",
                description:
                  "Geben Sie den Namen des Bonduelle-Produkts an, auf das sich Ihre Frage bezieht",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Detaillierte Informationen",
            description:
              "Für die Anfrage können Sie die entsprechenden Felder ausfüllen und ein Foto als Beispiel hinzufügen. Die Fotos müssen deutlich den Barcode, die Chargennummer und das Verfallsdatum des Produkts enthalten.",
            formFields: [
              {
                label: "Barcode des Produkts",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Der Barcode besteht aus \n13 Ziffern auf der\nVerpackung des Produkts.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "Chargennummer des Produkts",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Die Chargennummer beginnt mit einem L \n gefolgt von einer Reihe von Ziffern. \n Sie finden sie auf der Rückseite der Verpackung \n oder am Boden der Dose. \n\nZum Beispiel: L72450492107: 13.",
                // },
              },
              {
                label: "Verfallsdatum",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "Geben Sie das Datum wie folgt ein: TT/MM/JJJJ",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Das Verfallsdatum ist auf der Rückseite\nder Verpackung oder auf dem\nBoden der Dose angegeben.",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "Ihre Nachricht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schreiben Sie Ihre Nachricht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Weiteres Foto",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/kommentar-produkt",
        },
        seoTitle:
          "Hinterlassen Sie einen Kommentar zu einem Produkt | Bonduelle",
        seoDescription:
          "Haben Sie einen Hinweis oder Kommentar zu einem Produkt aus unserem Sortiment? Unser Verbraucherservice hilft Ihnen gerne weiter.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Kontaktiere den Presseservice",
        iconName: "newspaper",
        formSections: [],
        link: {
          url: "https://www.bonduelle.at/presse",
          is_external: true,
        },
      },
      {
        title: "Sonstige Anfragen",
        iconName: "question-bubble",
        formSections: [
          {
            title: "Frage",
            description: "",
            formFields: [
              {
                label: "Name",
                placeholder: "Ihr Name",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Vorname",
                placeholder: "Ihr Vorname",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "E-Mail Adresse",
                placeholder: "adresse@email.com",
                description: "",
                confirm: "E-Mail Adresse bestätigen",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                errorConfirm: "Bitte bestätigen Sie Ihre E-Mail-Adresse.",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "PLZ",
                placeholder: "PLZ",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Stadt",
                placeholder: "Ort",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefonnummer",
                placeholder: "Ihre Telefonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_de,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "Ihre Nachricht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schreiben Sie Ihre Nachricht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Weiteres Foto",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/sonstige-anfragen",
        },
        seoTitle: "Kontakt für sonstige Anfragen | Bonduelle",
        seoDescription:
          "Kontaktieren Sie unseren Verbraucherservice für Informationen, Service oder Vorschläge.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Frage zur Website und zur Barrierefreiheit",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_de,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/frage-website",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
  },
  {
    lang: {
      country: "be",
      code: "nl",
      default: false,
    },
    forms: [
      {
        title: "Vragen over een product?",
        iconName: "mystery-can",
        formSections: [
          {
            title: "Jouw gegevens",
            description: "",
            formFields: [
              {
                label: "Naam",
                placeholder: "Jouw naam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "Voornaam",
                placeholder: "Jouw voornaam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "Jouw e-mailadres",
                placeholder: "e-mailadres@email.com",
                description: "",
                confirm: "Bevestig jouw e-mailadres",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Voer alsjeblieft een geldig e-mailadres in",
                errorConfirm: "Bevestig alsjeblieft jouw e-mailadres",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "Jouw adres",
                placeholder: "Straat",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "Toevoeging van adres",
                placeholder: "Aanvullende informatie",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "Postcode",
                placeholder: "Postcode",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Woonplaats",
                placeholder: "Jouw woonplaats",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefoon",
                placeholder: "Jouw telefoonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_nl,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "Productinformatie",
            description:
              "Voer de volgende informatie in voor onze consumentenservice om jouw verzoek te behandelen:",
            formFields: [
              {
                label: "Naam van het product",
                placeholder: "",
                description:
                  "Noteer de naam van het Bonduelle product waarop je aanvraag betrekking heeft",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Gedetailleerde informatie",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "Barcode van het product",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "De barcode bestaat uit 13 cijfers\n op de verpakking van het product.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "Lotnummer van het product",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Het lotnummer begint met een L\n gevolgd door een aantal cijfers.\n Je kan deze vinden op de achterkant\n van de diepvries verpakking\n of aan de onderkant van het blik.\n\nBijvoorbeeld: L72450492107:13.",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Houdbaarheidsdatum",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "Voer de datum als volgt in: dd/mm/jjjj",
                width: 50,
                // hint: {
                //   description:
                //     "De houdbaarheidsdatum staat weergegeven op de achterkant van de diepvriesverpakking of aan de onderkant van het blik.",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Jouw bericht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "schrijf je bericht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "nl/neem-contact-met-ons-op/vragen-product",
        },
        seoTitle: "Vragen over een product? | Bonduelle",
        seoDescription:
          "Neem contact op met onze consumentenservice voor informatie over een product in ons assortiment.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Een opmerking over een product?",
        iconName: "bell",
        formSections: [
          {
            title: "Jouw gegevens",
            description: "",
            formFields: [
              {
                label: "Naam",
                placeholder: "Jouw naam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Voornaam",
                placeholder: "Jouw voornaam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Jouw e-mailadres",
                placeholder: "e-mailadres@email.com",
                description: "",
                confirm: "Bevestig jouw e-mailadres",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Voer alsjeblieft een geldig e-mailadres in",
                errorConfirm: "Bevestig alsjeblieft jouw e-mailadres",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Jouw adres",
                placeholder: "Straat",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "Toevoeging van adres",
                placeholder: "Aanvullende informatie",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "Postcode",
                placeholder: "Postcode",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Woonplaats",
                placeholder: "Jouw woonplaats",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefoon",
                placeholder: "Jouw telefoonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_nl,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Productinformatie",
            description:
              "Voer de volgende informatie in voor onze consumentenservice om jouw verzoek te behandelen:",
            formFields: [
              {
                label: "Naam van het product",
                placeholder: "",
                description:
                  "Noteer de naam van het Bonduelle product waarop je aanvraag betrekking heeft",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Gedetailleerde informatie",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "Barcode van het product",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "De barcode bestaat uit 13 cijfers op de verpakking van het product.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "Lotnummer van het product",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Houdbaarheidsdatum",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "Voer de datum als volgt in: dd/mm/jjjj",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Jouw bericht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "schrijf je bericht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "nl/neem-contact-met-ons-op/product-opmerking",
        },
        seoTitle: "Een opmerking over een product? | Bonduelle",
        seoDescription:
          "Een vraag of opmerking over een product in ons assortiment? Neem contact op met onze consumentenservice om u te helpen.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Vragen voor de pers?",
        iconName: "newspaper",
        formSections: [],
        link: {
          url: "mailto:consumerservices_blx_uk@bonduelle.com",
          is_external: true,
        },
      },
      {
        title: "Vragen of opmerkingen voor Bonduelle Foodservice?",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.be/contact",
          is_external: true,
        },
      },
      {
        title: "Suggesties over de website?",
        iconName: "desktop",
        formSections: [
          {
            title: "Jouw gegevens",
            description: "",
            formFields: [
              {
                label: "Naam",
                placeholder: "Jouw naam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Voornaam",
                placeholder: "Jouw voornaam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Jouw e-mailadres",
                placeholder: "e-mailadres@email.com",
                description: "",
                confirm: "Bevestig jouw e-mailadres",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Voer alsjeblieft een geldig e-mailadres in",
                errorConfirm: "Bevestig alsjeblieft jouw e-mailadres",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Telefoon",
                placeholder: "Jouw telefoonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "Jouw bericht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schrijf je bericht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Extra foto's",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "nl/neem-contact-met-ons-op/suggestie",
        },
        seoTitle:
          "Bericht voor verbetering, suggestie voor de website | Bonduelle",
        seoDescription:
          "Neem contact op met onze consumentenservice om ons te helpen de website te verbeteren.",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "46",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "46",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Een ander verzoek?",
        iconName: "question-bubble",
        formSections: [
          {
            title: "Jouw gegevens",
            description: "",
            formFields: [
              {
                label: "Naam",
                placeholder: "Jouw naam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Voornaam",
                placeholder: "Jouw voornaam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Jouw e-mailadres",
                placeholder: "e-mailadres@email.com",
                description: "",
                confirm: "Bevestig jouw e-mailadres",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Voer alsjeblieft een geldig e-mailadres in",
                errorConfirm: "Bevestig alsjeblieft jouw e-mailadres",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Telefoon",
                placeholder: "Jouw telefoonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "Jouw bericht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schrijf je bericht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Extra foto's",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "nl/neem-contact-met-ons-op/ander-verzoek",
        },
        seoTitle: "Andere vragen, opmerkingen of suggesties? | Bonduelle",
        seoDescription:
          "Neem contact op met onze consumentenservice voor vragen, opmerkingen of suggesties.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Vraag over de website en webtoegankelijkheid",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_nl,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/nl/neem-contact-met-ons-op/vraag-website",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
  },
  {
    lang: {
      country: "be",
      code: "fr",
      default: false,
    },
    forms: [
      {
        title: "Un renseignement sur un produit",
        iconName: "mystery-can",
        formSections: [
          {
            title: "Vos informations",
            description: "",
            formFields: [
              {
                label: "Nom",
                placeholder: "Votre nom",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "Prénom",
                placeholder: "Votre prénom",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "Votre email",
                placeholder: "monadresse@email.com",
                description: "",
                confirm: "Confirmez votre email",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Veuillez saisir une adresse email valide",
                errorConfirm: "Veuillez confirmer votre adresse email",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "Votre adresse",
                placeholder: "N° et nom de la rue",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "Complément d'adresse",
                placeholder: "Indications supplémentaires",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "Code postal",
                placeholder: "Code postal",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Ville",
                placeholder: "Votre ville de résidence",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Téléphone",
                placeholder: "Votre numéro de téléphone",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "Pays",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_be,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "Informations produits",
            description:
              "Afin que nos services puissent étudier au mieux votre demande, merci de renseigner les informations suivantes:",
            formFields: [
              {
                label: "Nom du produit",
                placeholder: "",
                description:
                  "Ecrivez le nom du produit Bonduelle concerné par votre demande",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Informations détaillées",
            description:
              "Pour chaque critère demandé, vous pouvez remplir le champ du formulaire et ajouter photos d’illustration. Votre photos doivent permettre de lire clairement le code barre, le numéro de lot et la DLUO du produit.<br> Note : Photos via PC ou ordinateur portable - fonction appareil photo non disponible.",
            formFields: [
              {
                label: "Code barre du produit",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Le code barre est composé\n de 13 chiffres présents sur\n l’emballage de votre produit.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "N° de lot du produit",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Le numéro de lot commence\n toujours pas la lettre L suivie\n de plusieurs chiffres et varie\n selon les produits.\n\nPar exemple L72450492107:13.",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              // {
              //   description: "",
              //   sfType: "SfFormImage",
              //   technicalName: "",
              //   required: false,
              //   autocomplete: "off",
              //   width: 50,
              // },
              {
                label: "Date de la DLUO / DLC",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "Veuillez saisir une date au format jj/mm/aaaa",
                width: 50,
                // hint: {
                //   description:
                //     "La DLUO (Date Limite d'Utilisation Optimale) et la DLC (Date limite de Consommation) sont présentées sous forme de dates.",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Votre message *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Ecrivez votre message",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "fr/nous-contacter/renseignement-produit",
        },
        seoTitle: "Renseignement et information sur un produit | Bonduelle",
        seoDescription:
          "Contactez notre service consommateur pour une information sur un produit de nos gammes. Réponse personnalisée dans les 48h",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Faire une remarque sur un produit",
        iconName: "bell",
        formSections: [
          {
            title: "Vos informations",
            description: "",
            formFields: [
              {
                label: "Nom",
                placeholder: "Votre nom",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Prénom",
                placeholder: "Votre prénom",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Votre email",
                placeholder: "monadresse@email.com",
                description: "",
                confirm: "Confirmez votre email",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Veuillez saisir une adresse email valide",
                errorConfirm: "Veuillez confirmer votre adresse email",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Votre adresse",
                placeholder: "N° et nom de la rue",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "Complément d'adresse",
                placeholder: "Indications supplémentaires",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "Code postal",
                placeholder: "Code postal",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Ville",
                placeholder: "Votre ville de résidence",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Téléphone",
                placeholder: "Votre numéro de téléphone",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "Pays",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_be,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Informations produits",
            description:
              "Afin que nos services puissent étudier au mieux votre demande, merci de renseigner les informations suivantes:",
            formFields: [
              {
                label: "Nom du produit",
                placeholder: "",
                description:
                  "Ecrivez le nom du produit Bonduelle concerné par votre demande",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Informations détaillées",
            description:
              "Pour chaque critère demandé, vous pouvez remplir le champ du formulaire et ajouter photos d’illustration. Votre photos doivent permettre de lire clairement le code barre, le numéro de lot et la DLUO du produit.<br> Note : Photos via PC ou ordinateur portable - fonction appareil photo non disponible.",
            formFields: [
              {
                label: "Code barre du produit",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Le code barre est composé\n de 13 chiffres présents sur\n l’emballage de votre produit.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "N° de lot du produit",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Le numéro de lot commence\n toujours pas la lettre L suivie\n de plusieurs chiffres et varie\n selon les produits.\n\nPar exemple L72450492107:13.",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Date de la DLUO / DLC",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "Veuillez saisir une date au format jj/mm/aaaa",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "La DLUO (Date Limite d'Utilisation Optimale) et la DLC (Date limite de Consommation) sont présentées sous forme de dates.",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Votre message *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Ecrivez votre message",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "fr/nous-contacter/remarque-produit",
        },
        seoTitle: "Remarque et commentaire sur un produit | Bonduelle",
        seoDescription:
          "Une remarque ou un commentaire sur un produit de nos gammes ? Contactez notre service consommateur pour vous aider. Réponse personnalisée dans les 48h",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Contacter le service presse",
        iconName: "newspaper",
        formSections: [],
        link: {
          url: "mailto:consumerservices_blx_uk@bonduelle.com",
          is_external: true,
        },
      },
      {
        title: "Contacter l’équipe Bonduelle Food Service",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.be/contact",
          is_external: true,
        },
      },
      {
        title: "Faire une suggestion à propos du site internet",
        iconName: "desktop",
        formSections: [
          {
            title: "Vos informations",
            description: "",
            formFields: [
              {
                label: "Nom",
                placeholder: "Votre nom",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Prénom",
                placeholder: "Votre prénom",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Votre email",
                placeholder: "monadresse@email.com",
                description: "",
                confirm: "Confirmez votre email",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Veuillez saisir une adresse email valide",
                errorConfirm: "Veuillez confirmer votre adresse email",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Téléphone",
                placeholder: "Votre numéro de téléphone",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "Votre message *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Ecrivez votre message",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "fr/nous-contacter/suggestion",
        },
        seoTitle: "Message d'amelioration, suggestion du site | Bonduelle",
        seoDescription:
          "Contactez notre service consommateur pour nous aider à améliorer le site et suggerer des pistes d'optimisation. Réponse personnalisée dans les 48h",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "46",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "46",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Faire une autre demande",
        iconName: "question-bubble",
        formSections: [
          {
            title: "Vos informations",
            description: "",
            formFields: [
              {
                label: "Nom",
                placeholder: "Votre nom",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Prénom",
                placeholder: "Votre prénom",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Votre email",
                placeholder: "monadresse@email.com",
                description: "",
                confirm: "Confirmez votre email",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Veuillez saisir une adresse email valide",
                errorConfirm: "Veuillez confirmer votre adresse email",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Téléphone",
                placeholder: "Votre numéro de téléphone",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "Votre message *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Ecrivez votre message",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Photos supplémentaires",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "fr/nous-contacter/autre-demande",
        },
        seoTitle: "Contact pour toute autre demande, service | Bonduelle",
        seoDescription:
          "Contactez notre service consommateur pour une information, un service ou une suggestion. Réponse personnalisée dans les 48h",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Question concernant le site web et l'accessibilité web",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_be,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "fr/nous-contacter/question-site-web",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
  },
  {
    lang: {
      country: "nl",
      code: "nl",
      default: true,
    },
    forms: [
      {
        title: "Vragen over een product?",
        iconName: "mystery-can",
        formSections: [
          {
            title: "Jouw gegevens",
            description: "",
            formFields: [
              {
                label: "Naam",
                placeholder: "Jouw naam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "Voornaam",
                placeholder: "Jouw voornaam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "Jouw e-mailadres",
                placeholder: "e-mailadres@email.com",
                description: "",
                confirm: "Bevestig jouw e-mailadres",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Voer alsjeblieft een geldig e-mailadres in",
                errorConfirm: "Bevestig alsjeblieft jouw e-mailadres",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "Jouw adres",
                placeholder: "Straat",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "Toevoeging van adres",
                placeholder: "Aanvullende informatie",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "Postcode",
                placeholder: "Postcode",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Woonplaats",
                placeholder: "Jouw woonplaats",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefoon",
                placeholder: "Jouw telefoonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_nl,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "Productinformatie",
            description:
              "Voer de volgende informatie in voor onze consumentenservice om jouw verzoek te behandelen:",
            formFields: [
              {
                label: "Naam van het product",
                placeholder: "",
                description:
                  "Noteer de naam van het Bonduelle product waarop je aanvraag betrekking heeft",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Gedetailleerde informatie",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "Barcode van het product",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "De barcode bestaat uit 13 cijfers\n op de verpakking van het product.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "Lotnummer van het product",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "Het lotnummer begint met een L\n gevolgd door een aantal cijfers.\n Je kan deze vinden op de achterkant\n van de diepvries verpakking\n of aan de onderkant van het blik.\n\nBijvoorbeeld: L72450492107:13.",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Houdbaarheidsdatum",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "Voer de datum als volgt in: dd/mm/jjjj",
                width: 50,
                // hint: {
                //   description:
                //     "De houdbaarheidsdatum staat weergegeven op de achterkant van de diepvriesverpakking of aan de onderkant van het blik.",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Jouw bericht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "schrijf je bericht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "neem-contact-met-ons-op/vragen-product",
        },
        seoTitle: "Vragen over een product? | Bonduelle",
        seoDescription:
          "Neem contact op met onze consumentenservice voor informatie over een product in ons assortiment.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Een opmerking over een product?",
        iconName: "bell",
        formSections: [
          {
            title: "Jouw gegevens",
            description: "",
            formFields: [
              {
                label: "Naam",
                placeholder: "Jouw naam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Voornaam",
                placeholder: "Jouw voornaam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Jouw e-mailadres",
                placeholder: "e-mailadres@email.com",
                description: "",
                confirm: "Bevestig jouw e-mailadres",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Voer alsjeblieft een geldig e-mailadres in",
                errorConfirm: "Bevestig alsjeblieft jouw e-mailadres",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Jouw adres",
                placeholder: "Straat",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "Toevoeging van adres",
                placeholder: "Aanvullende informatie",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "Postcode",
                placeholder: "Postcode",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Woonplaats",
                placeholder: "Jouw woonplaats",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "Telefoon",
                placeholder: "Jouw telefoonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "Land",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_nl,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Productinformatie",
            description:
              "Voer de volgende informatie in voor onze consumentenservice om jouw verzoek te behandelen:",
            formFields: [
              {
                label: "Naam van het product",
                placeholder: "",
                description:
                  "Noteer de naam van het Bonduelle product waarop je aanvraag betrekking heeft",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Gedetailleerde informatie",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "Barcode van het product",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description:
                //     "De barcode bestaat uit 13 cijfers op de verpakking van het product.",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "Lotnummer van het product",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "Houdbaarheidsdatum",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "Voer de datum als volgt in: dd/mm/jjjj",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "Jouw bericht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "schrijf je bericht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "neem-contact-met-ons-op/product-opmerking",
        },
        seoTitle: "Een opmerking over een product? | Bonduelle",
        seoDescription:
          "Een vraag of opmerking over een product in ons assortiment? Neem contact op met onze consumentenservice om u te helpen.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Vragen voor de pers?",
        iconName: "newspaper",
        formSections: [],
        link: {
          url: "mailto:consumerservices_blx_uk@bonduelle.com",
          is_external: true,
        },
      },
      {
        title: "Vragen of opmerkingen voor Bonduelle Foodservice?",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.nl/contact",
          is_external: true,
        },
      },
      {
        title: "Suggesties over de website?",
        iconName: "desktop",
        formSections: [
          {
            title: "Jouw gegevens",
            description: "",
            formFields: [
              {
                label: "Naam",
                placeholder: "Jouw naam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Voornaam",
                placeholder: "Jouw voornaam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Jouw e-mailadres",
                placeholder: "e-mailadres@email.com",
                description: "",
                confirm: "Bevestig jouw e-mailadres",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Voer alsjeblieft een geldig e-mailadres in",
                errorConfirm: "Bevestig alsjeblieft jouw e-mailadres",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Telefoon",
                placeholder: "Jouw telefoonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "Jouw bericht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schrijf je bericht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "neem-contact-met-ons-op/suggestie",
        },
        seoTitle:
          "Bericht voor verbetering, suggestie voor de website | Bonduelle",
        seoDescription:
          "Neem contact op met onze consumentenservice om ons te helpen de website te verbeteren.",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "46",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "46",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Een ander verzoek?",
        iconName: "question-bubble",
        formSections: [
          {
            title: "Jouw gegevens",
            description: "",
            formFields: [
              {
                label: "Naam",
                placeholder: "Jouw naam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "Voornaam",
                placeholder: "Jouw voornaam",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "Jouw e-mailadres",
                placeholder: "e-mailadres@email.com",
                description: "",
                confirm: "Bevestig jouw e-mailadres",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "Voer alsjeblieft een geldig e-mailadres in",
                errorConfirm: "Bevestig alsjeblieft jouw e-mailadres",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "Telefoon",
                placeholder: "Jouw telefoonnummer",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "Jouw bericht *",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "Schrijf je bericht",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "Extra foto's",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "neem-contact-met-ons-op/ander-verzoek",
        },
        seoTitle: "Andere vragen, opmerkingen of suggesties? | Bonduelle",
        seoDescription:
          "Neem contact op met onze consumentenservice voor vragen, opmerkingen of suggesties.",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Vraag over de website en webtoegankelijkheid",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_nl,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/neem-contact-met-ons-op/vraag-website",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
  },
  {
    lang: {
      country: "hu",
      code: "hu",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_hu,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kapcsolat/termekekkel-kapcsolatos-kerdesek",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_hu,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kapcsolat/termekekkel-kapcsolatos-reklamació",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "http://bonduelle-foodservice.hu/kontakty.php",
          is_external: true,
        },
      },
      {
        title: "FORM.JOB_OFFER.TITLE",
        iconName: "people_group",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_hu,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kapcsolat/allasajanlattal-kapcsolatos-kerdesek",
        },
        seoTitle: "FORM.JOB_OFFER.SEO_TITLE",
        seoDescription: "FORM.JOB_OFFER.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kapcsolat/egyeb-kerdesek",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title:
          "Kérdés a weboldallal és a webes akadálymentességgel kapcsolatban",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_hu,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kapcsolat/kerdes-weboldal",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "es",
      code: "es",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_es,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "2",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contacto/comentario-producto",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.es/contacto",
          is_external: true,
        },
      },
      {
        title: "FORM.WEB_SUGGESTION.TITLE",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contacto/sugerencia",
        },
        seoTitle: "FORM.WEB_SUGGESTION.SEO_TITLE",
        seoDescription: "FORM.WEB_SUGGESTION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contacto/otra-solicitud",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Pregunta sobre el sitio web y la accesibilidad web",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_es,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contacto/pregunta-sitio-web",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "pt",
      code: "pt",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_pt,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "2",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contacto/comentario-produto",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.pt/contacto",
          is_external: true,
        },
      },
      {
        title: "FORM.WEB_SUGGESTION.TITLE",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contacto/sugestao",
        },
        seoTitle: "FORM.WEB_SUGGESTION.SEO_TITLE",
        seoDescription: "FORM.WEB_SUGGESTION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contacto/outro-pedido",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Pergunta sobre o site e a acessibilidade web",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_pt,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contacto/pergunta-site-web",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "it",
      code: "it",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_it,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "2",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                  {
                    label: "FORM.CATEGORY.VEGETABLE",
                    value: "5",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contatto/informazioni-prodotto",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_it,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "2",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                  {
                    label: "FORM.CATEGORY.VEGETABLE",
                    value: "5",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contatto/commento-prodotto",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.SALES_OPERATIONS.TITLE",
        iconName: "etiquette",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: false,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
                type: "number",
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_it,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "2",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                  {
                    label: "FORM.CATEGORY.VEGETABLE",
                    value: "5",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                autocomplete: "off",
                type: "number",
                validators: "min(13), max(13)",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contatto/operazione-commerciale",
        },
        seoTitle: "FORM.SALES_OPERATIONS.SEO_TITLE",
        seoDescription: "FORM.SALES_OPERATIONS.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_OpeCom_Information",
          CS_UserChannel: "API_BEL_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_OpeCom_Information",
          CS_UserChannel: "API_FRESH_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRESS_SERVICE",
        iconName: "newspaper",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_it,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "2",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                  {
                    label: "FORM.CATEGORY.VEGETABLE",
                    value: "5",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contatto/vendere-prodotto",
        },
        seoTitle: "FORM.SALES_OPERATIONS.SEO_TITLE",
        seoDescription: "FORM.SALES_OPERATIONS.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_OpeCom_Information",
          CS_UserChannel: "API_BEL_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_OpeCom_Information",
          CS_UserChannel: "API_FRESH_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.WEB_SUGGESTION.TITLE",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_it,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contatto/suggerimento",
        },
        seoTitle: "FORM.WEB_SUGGESTION.SEO_TITLE",
        seoDescription: "FORM.WEB_SUGGESTION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.AMBASSADOR",
        iconName: "ambassador",
        formSections: [],
        link: {
          url: "/lavora-con-noi",
        },
      },
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.it/contatto",
          is_external: true,
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contatto/altra-richiesta",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Domanda sul sito web e sull’accessibilità web",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_it,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contatto/domanda-sito-web",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "cz",
      code: "cs",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_cz,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/informace-o-produktech",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_cz,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/poznamky-k-produktum",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      /**{
        title: 'FORM.SALES_OPERATIONS.TITLE',
        iconName: 'etiquette',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name'
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email'
              },
              {
                label: 'FORM.ADDRESS',
                placeholder: 'FORM.STREET',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address1',
                required: false,
                width: 50,
                autocomplete: 'address-line1'
              },
              {
                label: 'FORM.ADDRESS_COMPLEMENT',
                placeholder: 'FORM.ADDRESS_COMP_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address2',
                required: false,
                width: 50,
                autocomplete: 'address-line2'
              },
              {
                label: 'FORM.ZIPCODE',
                placeholder: 'FORM.ZIPCODE',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                validationRegex: '',
                technicalName: 'ZipCode',
                required: false,
                autocomplete: 'off',
                width: 25,
                type: 'number'
              },
              {
                label: 'FORM.CITY',
                placeholder: 'FORM.CITY_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'City',
                required: false,
                autocomplete: 'off',
                width: 25
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: true,
                width: 50,
                autocomplete: 'tel'
              },
              {
                label: 'FORM.COUNTRY',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: countries,
                technicalName: 'Country',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ],
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS',
            description: 'FORM.PRODUCT_INFORMATION_DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_RANGE',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: [
                  {
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },
                  {
                    label: 'FORM.CATEGORY.CAN',
                    value: '1'
                  },
                  {
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }
                ],
                technicalName: 'CS_Technology',
                required: true,
                autocomplete: 'off',
                width: 50
              },
              {
                label: 'FORM.PRODUCT_NAME',
                placeholder: '',
                description: 'FORM.PRODUCT_NAME_PLH',
                sfType: 'SfFormTextField',
                technicalName: 'CS_MarketingDescription',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ]
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS_DETAIL',
            description: 'FORM.PRODUCT.DETAIL.DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                required: false,
                autocomplete: 'off',
                type: 'number',
                validators: 'min(13), max(13)',
                width: 50,
                hint: {
                  description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                  image: '/assets/images/barcode.png'
                }
              },
              {
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                width: 50
              }
            ]
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt/operation-commerciale'
        },
        seoTitle: 'FORM.SALES_OPERATIONS.SEO_TITLE',
        seoDescription: 'FORM.SALES_OPERATIONS.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_OpeCom_Information',
          CS_UserChannel: 'API_BEL_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_OpeCom_Information',
          CS_UserChannel: 'API_FRESH_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.PRESS_SERVICE',
        iconName: 'newspaper',
        formSections: [],
        link: {
          url: 'https://www.bonduelle.com/fr/journalistes/contact-presse.html',
          is_external: true
        }
      },*/
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "http://www.bonduelle-foodservice.cz/",
          is_external: true,
        },
      },
      /**{
        title: 'FORM.WEB_SUGGESTION.TITLE',
        iconName: 'desktop',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name',
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email',
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: false,
                width: 50,
                autocomplete: 'tel',
              }
            ],
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt/suggestion'
        },
        seoTitle: 'FORM.WEB_SUGGESTION.SEO_TITLE',
        seoDescription: 'FORM.WEB_SUGGESTION.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_eCommerce_NavSite',
          CS_UserChannel: 'API_BEL_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_eCommerce_NavSite',
          CS_UserChannel: 'API_FRESH_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.AMBASSADOR',
        iconName: 'ambassador',
        formSections: [],
        link: {
          url: 'http://monpaniersecret.bonduelle.com/contact/?profil=devenir',
          is_external: true
        }
      },*/
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/jiny-pozadavek",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Dotaz týkající se webu a webové přístupnosti",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_cz,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/otazka-webova-stranka",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "sk",
      code: "sk",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_cz,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/informacie-o-vyrobkoch",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_cz,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: true,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/poznamky-k-vyrobkom",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      /**{
        title: 'FORM.SALES_OPERATIONS.TITLE',
        iconName: 'etiquette',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name'
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email'
              },
              {
                label: 'FORM.ADDRESS',
                placeholder: 'FORM.STREET',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address1',
                required: false,
                width: 50,
                autocomplete: 'address-line1'
              },
              {
                label: 'FORM.ADDRESS_COMPLEMENT',
                placeholder: 'FORM.ADDRESS_COMP_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address2',
                required: false,
                width: 50,
                autocomplete: 'address-line2'
              },
              {
                label: 'FORM.ZIPCODE',
                placeholder: 'FORM.ZIPCODE',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                validationRegex: '',
                technicalName: 'ZipCode',
                required: false,
                autocomplete: 'off',
                width: 25,
                type: 'number'
              },
              {
                label: 'FORM.CITY',
                placeholder: 'FORM.CITY_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'City',
                required: false,
                autocomplete: 'off',
                width: 25
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: true,
                width: 50,
                autocomplete: 'tel'
              },
              {
                label: 'FORM.COUNTRY',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: countries,
                technicalName: 'Country',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ],
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS',
            description: 'FORM.PRODUCT_INFORMATION_DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_RANGE',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: [
                  {
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },
                  {
                    label: 'FORM.CATEGORY.CAN',
                    value: '1'
                  },
                  {
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }
                ],
                technicalName: 'CS_Technology',
                required: true,
                autocomplete: 'off',
                width: 50
              },
              {
                label: 'FORM.PRODUCT_NAME',
                placeholder: '',
                description: 'FORM.PRODUCT_NAME_PLH',
                sfType: 'SfFormTextField',
                technicalName: 'CS_MarketingDescription',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ]
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS_DETAIL',
            description: 'FORM.PRODUCT.DETAIL.DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                required: false,
                autocomplete: 'off',
                type: 'number',
                validators: 'min(13), max(13)',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },
              {
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                width: 50
              }
            ]
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt/operation-commerciale'
        },
        seoTitle: 'FORM.SALES_OPERATIONS.SEO_TITLE',
        seoDescription: 'FORM.SALES_OPERATIONS.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_OpeCom_Information',
          CS_UserChannel: 'API_BEL_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_OpeCom_Information',
          CS_UserChannel: 'API_FRESH_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.PRESS_SERVICE',
        iconName: 'newspaper',
        formSections: [],
        link: {
          url: 'https://www.bonduelle.com/fr/journalistes/contact-presse.html',
          is_external: true
        }
      },*/
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "http://www.bonduelle-foodservice.cz/",
          is_external: true,
        },
      },
      /**{
        title: 'FORM.WEB_SUGGESTION.TITLE',
        iconName: 'desktop',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name',
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email',
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: false,
                width: 50,
                autocomplete: 'tel',
              }
            ],
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt/suggestion'
        },
        seoTitle: 'FORM.WEB_SUGGESTION.SEO_TITLE',
        seoDescription: 'FORM.WEB_SUGGESTION.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_eCommerce_NavSite',
          CS_UserChannel: 'API_BEL_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_eCommerce_NavSite',
          CS_UserChannel: 'API_FRESH_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.AMBASSADOR',
        iconName: 'ambassador',
        formSections: [],
        link: {
          url: 'http://monpaniersecret.bonduelle.com/contact/?profil=devenir',
          is_external: true
        }
      },*/
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/ina-poziadavka",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Otázka týkajúca sa webovej stránky a prístupnosti webu",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_cz,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/otazka-webova-stranka",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "dk",
      code: "da",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_dk_se_fi_no,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  /*{
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },*/
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  /*{
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }*/
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              /* {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                type: 'number',
                validators: 'min(13), max(13)',
                required: true,
                autocomplete: 'off',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },*/
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              /* {
                label: 'FORM.EXPIRED_DATE',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_DLUODLC',
                error: 'FORM.EXPIRED_DATE_ERROR',
                required: false,
                autocomplete: 'off',
                width: 50,
                // hint: {
                //   description: 'FORM.EXPIRED_DATE_DESC'
                // },
                type: 'date'
              },}*/
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt-os/produkt-noter",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      /*{
        title: 'FORM.SALES_OPERATIONS.TITLE',
        iconName: 'etiquette',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name'
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email'
              },
              {
                label: 'FORM.ADDRESS',
                placeholder: 'FORM.STREET',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address1',
                required: false,
                width: 50,
                autocomplete: 'address-line1'
              },
              {
                label: 'FORM.ADDRESS_COMPLEMENT',
                placeholder: 'FORM.ADDRESS_COMP_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address2',
                required: false,
                width: 50,
                autocomplete: 'address-line2'
              },
              {
                label: 'FORM.ZIPCODE',
                placeholder: 'FORM.ZIPCODE',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                validationRegex: '',
                technicalName: 'ZipCode',
                required: false,
                autocomplete: 'off',
                width: 25,
                type: 'number'
              },
              {
                label: 'FORM.CITY',
                placeholder: 'FORM.CITY_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'City',
                required: false,
                autocomplete: 'off',
                width: 25
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: true,
                width: 50,
                autocomplete: 'tel'
              },
              {
                label: 'FORM.COUNTRY',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: countries,
                technicalName: 'Country',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ],
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS',
            description: 'FORM.PRODUCT_INFORMATION_DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_RANGE',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: [
                  {
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },
                  {
                    label: 'FORM.CATEGORY.CAN',
                    value: '1'
                  },
                  {
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }
                ],
                technicalName: 'CS_Technology',
                required: true,
                autocomplete: 'off',
                width: 50
              },
              {
                label: 'FORM.PRODUCT_NAME',
                placeholder: '',
                description: 'FORM.PRODUCT_NAME_PLH',
                sfType: 'SfFormTextField',
                technicalName: 'CS_MarketingDescription',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ]
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS_DETAIL',
            description: 'FORM.PRODUCT.DETAIL.DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                required: false,
                autocomplete: 'off',
                type: 'number',
                validators: 'min(13), max(13)',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },
              {
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                width: 50
              }
            ]
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt-os/operation-commerciale'
        },
        seoTitle: 'FORM.SALES_OPERATIONS.SEO_TITLE',
        seoDescription: 'FORM.SALES_OPERATIONS.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_OpeCom_Information',
          CS_UserChannel: 'API_BEL_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_OpeCom_Information',
          CS_UserChannel: 'API_FRESH_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.PRESS_SERVICE',
        iconName: 'newspaper',
        formSections: [],
        link: {
          url: 'https://www.bonduelle.com/fr/journalistes/contact-presse.html',
          is_external: true
        }
      },
      // {
      //   title: 'FORM.FOOD_SERVICE',
      //   iconName: 'chef',
      //   formSections: [],
      //   link: {
      //     url: 'https://www.bonduelle-foodservice.dk/kontakt',
      //     is_external: true
      //   }
      // },
      /*{
        title: 'FORM.WEB_SUGGESTION.TITLE',
        iconName: 'desktop',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name',
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email',
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: false,
                width: 50,
                autocomplete: 'tel',
              }
            ],
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt-os/suggestion'
        },
        seoTitle: 'FORM.WEB_SUGGESTION.SEO_TITLE',
        seoDescription: 'FORM.WEB_SUGGESTION.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_eCommerce_NavSite',
          CS_UserChannel: 'API_BEL_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_eCommerce_NavSite',
          CS_UserChannel: 'API_FRESH_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.AMBASSADOR',
        iconName: 'ambassador',
        formSections: [],
        link: {
          url: 'http://monpaniersecret.bonduelle.com/contact/?profil=devenir',
          is_external: true
        }
      },*/
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          /*{
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }*/
        ],
        link: {
          url: "/kontakt-os/forslag",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Spørgsmål om hjemmesiden og webtilgængelighed",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_dk_se_fi_no,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt-os/spoergsmaal-hjemmeside",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "pl",
      code: "pl",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_pl,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "2",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  {
                    label: "FORM.CATEGORY.TAKEAWAY",
                    value: "4",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/pytania-produkty",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: false,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_pl,
                technicalName: "Country",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.SALAD",
                    value: "2",
                  },
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  // {
                  //   label: 'FORM.CATEGORY.TAKEAWAY',
                  //   value: '4'
                  // }
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                hint: {
                  description: "FORM.PRODUCT_LOT_INFO",
                },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/Reklamacje",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.pl/formularz-kontaktowy.html",
          is_external: true,
        },
      },
      {
        title: "Oferty pracy",
        iconName: "ambassador",
        formSections: [],
        link: {
          url: "https://jobs.bonduelle.com/?locale=pl_PL",
          is_external: true,
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/inne-pytania",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Pytanie dotyczące strony internetowej i dostępności w sieci",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_pl,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/pytanie-strona-internetowa",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "lt",
      code: "lt",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: false,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_lv_lt,
                technicalName: "Country",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "šaldyti",
                    value: "3",
                  },
                  {
                    label: "konservuoti",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontaktai/produkto-pastaba",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.SALES_OPERATIONS.TITLE",
        iconName: "etiquette",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: false,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
                type: "number",
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_lv_lt,
                technicalName: "Country",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "šaldyti",
                    value: "3",
                  },
                  {
                    label: "konservuoti",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                autocomplete: "off",
                type: "number",
                validators: "min(13), max(13)",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontaktai/komercine-operacija",
        },
        seoTitle: "FORM.SALES_OPERATIONS.SEO_TITLE",
        seoDescription: "FORM.SALES_OPERATIONS.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_OpeCom_Information",
          CS_UserChannel: "API_BEL_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_OpeCom_Information",
          CS_UserChannel: "API_FRESH_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.FOOD_SERVICE",
        iconName: "chef",
        formSections: [],
        link: {
          url: "https://www.bonduelle-foodservice.lt",
          is_external: true,
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontaktai/kitas-prasymas",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Klausimas apie svetainę ir interneto prieinamumą",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_lv_lt,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontaktai/klausimas-interneto-svetaine",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "lv",
      code: "lv",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: false,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_lv_lt,
                technicalName: "Country",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "šaldyti",
                    value: "3",
                  },
                  {
                    label: "konservuoti",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakti/komentars-par-produktu",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.SALES_OPERATIONS.TITLE",
        iconName: "etiquette",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: false,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
                type: "number",
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_lv_lt,
                technicalName: "Country",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "šaldyti",
                    value: "3",
                  },
                  {
                    label: "konservuoti",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                autocomplete: "off",
                type: "number",
                validators: "min(13), max(13)",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakti/informacija-par-pirkumu",
        },
        seoTitle: "FORM.SALES_OPERATIONS.SEO_TITLE",
        seoDescription: "FORM.SALES_OPERATIONS.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_OpeCom_Information",
          CS_UserChannel: "API_BEL_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_OpeCom_Information",
          CS_UserChannel: "API_FRESH_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakti/iesniedziet-ierosinajumu",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Klausimas apie svetainę ir interneto prieinamumą",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_lv_lt,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakti/jautajums-tīmekļa-lapa",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "ee",
      code: "et",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: false,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ee,
                technicalName: "Country",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "külmutatud",
                    value: "3",
                  },
                  {
                    label: "konserveeritud",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/tooteinfo",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.SALES_OPERATIONS.TITLE",
        iconName: "etiquette",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: false,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
                type: "number",
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ee,
                technicalName: "Country",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "külmutatud",
                    value: "3",
                  },
                  {
                    label: "konserveeritud",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                autocomplete: "off",
                type: "number",
                validators: "min(13), max(13)",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/ostuinfo",
        },
        seoTitle: "FORM.SALES_OPERATIONS.SEO_TITLE",
        seoDescription: "FORM.SALES_OPERATIONS.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_OpeCom_Information",
          CS_UserChannel: "API_BEL_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_OpeCom_Information",
          CS_UserChannel: "API_FRESH_OpeCom_Information",
          Category: "9",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: false,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/esita-ettepanek",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Küsimus veebisaidi ja veebi ligipääsetavuse kohta",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ee,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/kusimus-veebileht",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "fi",
      code: "fi",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_fi,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  /*{
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },*/
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  /*{
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }*/
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              /* {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                type: 'number',
                validators: 'min(13), max(13)',
                required: true,
                autocomplete: 'off',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },*/
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              /*{
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 50
              },*/
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              /* {
                label: 'FORM.EXPIRED_DATE',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_DLUODLC',
                error: 'FORM.EXPIRED_DATE_ERROR',
                required: false,
                autocomplete: 'off',
                width: 50,
                // hint: {
                //   description: 'FORM.EXPIRED_DATE_DESC'
                // },
                type: 'date'
              },*/
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/ota-yhteytta/produkt-noter",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      /*{
        title: 'FORM.SALES_OPERATIONS.TITLE',
        iconName: 'etiquette',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name'
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email'
              },
              {
                label: 'FORM.ADDRESS',
                placeholder: 'FORM.STREET',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address1',
                required: false,
                width: 50,
                autocomplete: 'address-line1'
              },
              {
                label: 'FORM.ADDRESS_COMPLEMENT',
                placeholder: 'FORM.ADDRESS_COMP_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address2',
                required: false,
                width: 50,
                autocomplete: 'address-line2'
              },
              {
                label: 'FORM.ZIPCODE',
                placeholder: 'FORM.ZIPCODE',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                validationRegex: '',
                technicalName: 'ZipCode',
                required: false,
                autocomplete: 'off',
                width: 25,
                type: 'number'
              },
              {
                label: 'FORM.CITY',
                placeholder: 'FORM.CITY_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'City',
                required: false,
                autocomplete: 'off',
                width: 25
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: true,
                width: 50,
                autocomplete: 'tel'
              },
              {
                label: 'FORM.COUNTRY',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: countries,
                technicalName: 'Country',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ],
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS',
            description: 'FORM.PRODUCT_INFORMATION_DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_RANGE',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: [
                  {
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },
                  {
                    label: 'FORM.CATEGORY.CAN',
                    value: '1'
                  },
                  {
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }
                ],
                technicalName: 'CS_Technology',
                required: true,
                autocomplete: 'off',
                width: 50
              },
              {
                label: 'FORM.PRODUCT_NAME',
                placeholder: '',
                description: 'FORM.PRODUCT_NAME_PLH',
                sfType: 'SfFormTextField',
                technicalName: 'CS_MarketingDescription',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ]
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS_DETAIL',
            description: 'FORM.PRODUCT.DETAIL.DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                required: false,
                autocomplete: 'off',
                type: 'number',
                validators: 'min(13), max(13)',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },
              {
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                width: 50
              }
            ]
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt-os/operation-commerciale'
        },
        seoTitle: 'FORM.SALES_OPERATIONS.SEO_TITLE',
        seoDescription: 'FORM.SALES_OPERATIONS.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_OpeCom_Information',
          CS_UserChannel: 'API_BEL_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_OpeCom_Information',
          CS_UserChannel: 'API_FRESH_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.PRESS_SERVICE',
        iconName: 'newspaper',
        formSections: [],
        link: {
          url: 'https://www.bonduelle.com/fr/journalistes/contact-presse.html',
          is_external: true
        }
      },*/
      // {
      //   title: 'FORM.FOOD_SERVICE',
      //   iconName: 'chef',
      //   formSections: [],
      //   link: {
      //     url: 'https://www.bonduelle-foodservice.fi/yhteydenotto',
      //     is_external: true
      //   }
      // },
      /*{
        title: 'FORM.WEB_SUGGESTION.TITLE',
        iconName: 'desktop',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name',
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email',
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: false,
                width: 50,
                autocomplete: 'tel',
              }
            ],
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt-os/suggestion'
        },
        seoTitle: 'FORM.WEB_SUGGESTION.SEO_TITLE',
        seoDescription: 'FORM.WEB_SUGGESTION.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_eCommerce_NavSite',
          CS_UserChannel: 'API_BEL_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_eCommerce_NavSite',
          CS_UserChannel: 'API_FRESH_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.AMBASSADOR',
        iconName: 'ambassador',
        formSections: [],
        link: {
          url: 'http://monpaniersecret.bonduelle.com/contact/?profil=devenir',
          is_external: true
        }
      },*/
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          /*{
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }*/
        ],
        link: {
          url: "/ota-yhteytta/forslag",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Kysymys verkkosivustosta ja verkkosivujen saavutettavuudesta",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_fi,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/ota-yhteytta/digitaalinen-saavutettavuus",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "se",
      code: "sv",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_se,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  /*{
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },*/
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  /*{
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }*/
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              /* {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                type: 'number',
                validators: 'min(13), max(13)',
                required: true,
                autocomplete: 'off',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },*/
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              /*{
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 50
              },*/
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              /* {
                label: 'FORM.EXPIRED_DATE',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_DLUODLC',
                error: 'FORM.EXPIRED_DATE_ERROR',
                required: false,
                autocomplete: 'off',
                width: 50,
                // hint: {
                //   description: 'FORM.EXPIRED_DATE_DESC'
                // },
                type: 'date'
              },*/
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakta-oss/produkt-noter",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      /*{
        title: 'FORM.SALES_OPERATIONS.TITLE',
        iconName: 'etiquette',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name'
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email'
              },
              {
                label: 'FORM.ADDRESS',
                placeholder: 'FORM.STREET',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address1',
                required: false,
                width: 50,
                autocomplete: 'address-line1'
              },
              {
                label: 'FORM.ADDRESS_COMPLEMENT',
                placeholder: 'FORM.ADDRESS_COMP_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address2',
                required: false,
                width: 50,
                autocomplete: 'address-line2'
              },
              {
                label: 'FORM.ZIPCODE',
                placeholder: 'FORM.ZIPCODE',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                validationRegex: '',
                technicalName: 'ZipCode',
                required: false,
                autocomplete: 'off',
                width: 25,
                type: 'number'
              },
              {
                label: 'FORM.CITY',
                placeholder: 'FORM.CITY_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'City',
                required: false,
                autocomplete: 'off',
                width: 25
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: true,
                width: 50,
                autocomplete: 'tel'
              },
              {
                label: 'FORM.COUNTRY',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: countries,
                technicalName: 'Country',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ],
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS',
            description: 'FORM.PRODUCT_INFORMATION_DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_RANGE',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: [
                  {
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },
                  {
                    label: 'FORM.CATEGORY.CAN',
                    value: '1'
                  },
                  {
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }
                ],
                technicalName: 'CS_Technology',
                required: true,
                autocomplete: 'off',
                width: 50
              },
              {
                label: 'FORM.PRODUCT_NAME',
                placeholder: '',
                description: 'FORM.PRODUCT_NAME_PLH',
                sfType: 'SfFormTextField',
                technicalName: 'CS_MarketingDescription',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ]
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS_DETAIL',
            description: 'FORM.PRODUCT.DETAIL.DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                required: false,
                autocomplete: 'off',
                type: 'number',
                validators: 'min(13), max(13)',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },
              {
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                width: 50
              }
            ]
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt-os/operation-commerciale'
        },
        seoTitle: 'FORM.SALES_OPERATIONS.SEO_TITLE',
        seoDescription: 'FORM.SALES_OPERATIONS.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_OpeCom_Information',
          CS_UserChannel: 'API_BEL_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_OpeCom_Information',
          CS_UserChannel: 'API_FRESH_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.PRESS_SERVICE',
        iconName: 'newspaper',
        formSections: [],
        link: {
          url: 'https://www.bonduelle.com/fr/journalistes/contact-presse.html',
          is_external: true
        }
      },*/
      // {
      //   title: 'FORM.FOOD_SERVICE',
      //   iconName: 'chef',
      //   formSections: [],
      //   link: {
      //     url: 'https://www.bonduelle-foodservice.se/kontakt',
      //     is_external: true
      //   }
      // },
      /*{
        title: 'FORM.WEB_SUGGESTION.TITLE',
        iconName: 'desktop',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name',
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email',
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: false,
                width: 50,
                autocomplete: 'tel',
              }
            ],
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt-os/suggestion'
        },
        seoTitle: 'FORM.WEB_SUGGESTION.SEO_TITLE',
        seoDescription: 'FORM.WEB_SUGGESTION.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_eCommerce_NavSite',
          CS_UserChannel: 'API_BEL_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_eCommerce_NavSite',
          CS_UserChannel: 'API_FRESH_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.AMBASSADOR',
        iconName: 'ambassador',
        formSections: [],
        link: {
          url: 'http://monpaniersecret.bonduelle.com/contact/?profil=devenir',
          is_external: true
        }
      },*/
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          /*{
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }*/
        ],
        link: {
          url: "/kontakta-oss/forslag",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Fråga om webbplatsen och webbtillgänglighet",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakta-oss/kysymys-verkkosivusto",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "no",
      code: "no",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_se,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  /*{
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },*/
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                  /*{
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }*/
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              /* {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                type: 'number',
                validators: 'min(13), max(13)',
                required: true,
                autocomplete: 'off',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },*/
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              /*{
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 50
              },*/
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              /* {
                label: 'FORM.EXPIRED_DATE',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_DLUODLC',
                error: 'FORM.EXPIRED_DATE_ERROR',
                required: false,
                autocomplete: 'off',
                width: 50,
                // hint: {
                //   description: 'FORM.EXPIRED_DATE_DESC'
                // },
                type: 'date'
              },*/
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt-oss/produkt-noter",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      /*{
        title: 'FORM.SALES_OPERATIONS.TITLE',
        iconName: 'etiquette',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name'
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email'
              },
              {
                label: 'FORM.ADDRESS',
                placeholder: 'FORM.STREET',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address1',
                required: false,
                width: 50,
                autocomplete: 'address-line1'
              },
              {
                label: 'FORM.ADDRESS_COMPLEMENT',
                placeholder: 'FORM.ADDRESS_COMP_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'Address2',
                required: false,
                width: 50,
                autocomplete: 'address-line2'
              },
              {
                label: 'FORM.ZIPCODE',
                placeholder: 'FORM.ZIPCODE',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                validationRegex: '',
                technicalName: 'ZipCode',
                required: false,
                autocomplete: 'off',
                width: 25,
                type: 'number'
              },
              {
                label: 'FORM.CITY',
                placeholder: 'FORM.CITY_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'City',
                required: false,
                autocomplete: 'off',
                width: 25
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: true,
                width: 50,
                autocomplete: 'tel'
              },
              {
                label: 'FORM.COUNTRY',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: countries,
                technicalName: 'Country',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ],
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS',
            description: 'FORM.PRODUCT_INFORMATION_DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_RANGE',
                placeholder: '',
                description: '',
                sfType: 'SfFormSelect',
                default: '',
                values: [
                  {
                    label: 'FORM.CATEGORY.SALAD',
                    value: '2'
                  },
                  {
                    label: 'FORM.CATEGORY.FROZEN',
                    value: '3'
                  },
                  {
                    label: 'FORM.CATEGORY.CAN',
                    value: '1'
                  },
                  {
                    label: 'FORM.CATEGORY.TAKEAWAY',
                    value: '4'
                  }
                ],
                technicalName: 'CS_Technology',
                required: true,
                autocomplete: 'off',
                width: 50
              },
              {
                label: 'FORM.PRODUCT_NAME',
                placeholder: '',
                description: 'FORM.PRODUCT_NAME_PLH',
                sfType: 'SfFormTextField',
                technicalName: 'CS_MarketingDescription',
                required: false,
                autocomplete: 'off',
                width: 50
              }
            ]
          },
          {
            title: 'FORM.PRODUCT_INFORMATIONS_DETAIL',
            description: 'FORM.PRODUCT.DETAIL.DESC',
            formFields: [
              {
                label: 'FORM.PRODUCT_INFORMATIONS_LABEL',
                placeholder: '',
                description: '',
                sfType: 'SfFormTextField',
                technicalName: 'CS_UCEANCode',
                required: false,
                autocomplete: 'off',
                type: 'number',
                validators: 'min(13), max(13)',
                width: 50,
                // hint: {
                //   description: 'FORM.PRODUCT_INFORMATIONS_PLH',
                //   image: '/assets/images/barcode.png'
                // }
              },
              {
                description: '',
                sfType: 'SfFormImage',
                technicalName: '',
                required: false,
                width: 50
              }
            ]
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt-os/operation-commerciale'
        },
        seoTitle: 'FORM.SALES_OPERATIONS.SEO_TITLE',
        seoDescription: 'FORM.SALES_OPERATIONS.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_OpeCom_Information',
          CS_UserChannel: 'API_BEL_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_OpeCom_Information',
          CS_UserChannel: 'API_FRESH_OpeCom_Information',
          Category: '9',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.PRESS_SERVICE',
        iconName: 'newspaper',
        formSections: [],
        link: {
          url: 'https://www.bonduelle.com/fr/journalistes/contact-presse.html',
          is_external: true
        }
      },*/
      // {
      //   title: 'FORM.FOOD_SERVICE',
      //   iconName: 'chef',
      //   formSections: [],
      //   link: {
      //     url: 'https://www.bonduelle-foodservice.dk/kontakt',
      //     is_external: true
      //   }
      // },
      /*{
        title: 'FORM.WEB_SUGGESTION.TITLE',
        iconName: 'desktop',
        formSections: [
          {
            title: 'FORM.INFORMATIONS',
            description: '',
            formFields: [
              {
                label: 'FORM.NAME',
                placeholder: 'FORM.OUR_NAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'LastName',
                required: true,
                width: 50,
                autocomplete: 'family-name',
              },
              {
                label: 'FORM.FIRSTNAME',
                placeholder: 'FORM.OUR_FIRSTNAME',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'FirstName',
                required: true,
                width: 50,
                autocomplete: 'given-name'
              },
              {
                label: 'FORM.MAIL',
                placeholder: 'FORM.MAIL_PLH',
                description: '',
                confirm: 'FORM.MAIL_CONFIRM',
                sfType: 'SfFormTextFieldConfirm',
                style: 'underline',
                technicalName: 'EMail',
                validators: ['email'],
                error: 'FORM.MAIL_ERROR',
                errorConfirm: 'FORM.MAIL_ERROR_CONFIRM',
                required: true,
                width: 100,
                autocomplete: 'email',
              },
              {
                label: 'FORM.PHONE',
                placeholder: 'FORM.PHONE_PLH',
                description: '',
                sfType: 'SfFormTextField',
                style: 'underline',
                technicalName: 'DirectLine',
                validators: ['phone'],
                required: false,
                width: 50,
                autocomplete: 'tel',
              }
            ],
          },
          {
            title: 'FORM.MESSAGE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: 'FORM.OUR_MESSAGE',
                description: '',
                sfType: 'SfFormTextArea',
                style: 'underline',
                technicalName: 'Request',
                required: true,
                autocomplete: 'off',
                width: 100
              }
            ]
          },
          {
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }
        ],
        link: {
          url: '/kontakt-os/suggestion'
        },
        seoTitle: 'FORM.WEB_SUGGESTION.SEO_TITLE',
        seoDescription: 'FORM.WEB_SUGGESTION.SEO_DESC',
        channelBellInfo: {
          Channel: 'API_BEL_eCommerce_NavSite',
          CS_UserChannel: 'API_BEL_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '1',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        },
        channelFreshInfo: {
          Channel: 'API_FRESH_eCommerce_NavSite',
          CS_UserChannel: 'API_FRESH_eCommerce_NavSite',
          Category: '42',
          CS_SalesNetwork: '1',
          CS_Technology: '2',
          CS_Brand: '3',
          CS_PurchaseCountry: '2',
          CS_autoAffectationWS: '1'
        }
      },
      {
        title: 'FORM.AMBASSADOR',
        iconName: 'ambassador',
        formSections: [],
        link: {
          url: 'http://monpaniersecret.bonduelle.com/contact/?profil=devenir',
          is_external: true
        }
      },*/
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          /*{
            title: 'FORM.PHOTO_MORE',
            description: '',
            formFields: [
              {
                label: '',
                placeholder: '',
                description: '',
                sfType: 'SfFormImageMulti',
                technicalName: '',
                required: false,
                autocomplete: 'off',
                width: 100
              }
            ],
          }*/
        ],
        link: {
          url: "/kontakt-oss/forslag",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Spørsmål om nettstedet og webtilgjengelighet",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_no,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt-oss/sporsmal-nettsted",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "al",
      code: "sq",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_al,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontaktoni/informacija-o-proizvodu",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_al,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontaktoni/komentarisite-proizvod",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_al,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontaktoni/napravite-novi-zahtev",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title:
          "Pyetje në lidhje me faqen e internetit dhe aksesueshmërinë në internet",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_al,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontaktoni/pyetje-faqe-web",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "rs",
      code: "sr",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_rs,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/informacion-per-produktin",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_rs,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
              {
                description: "",
                sfType: "SfFormImage",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/komentoni-per-nje-produkt",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.ANOTHER.TITLE",
        iconName: "question-bubble",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: false,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_rs,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
          {
            title: "FORM.PHOTO_MORE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "",
                description: "",
                sfType: "SfFormImageMulti",
                technicalName: "",
                required: false,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/beni-nje-kerkese-tjeter",
        },
        seoTitle: "FORM.ANOTHER.SEO_TITLE",
        seoDescription: "FORM.ANOTHER/SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Pitanje u vezi sa veb-sajtom i pristupačnošću veba",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_rs,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/kontakt/pitanje-veb-stranica",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "gr",
      code: "el",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_gr,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/epikoinonia/plirofories-proiontos",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_gr,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/epikoinonia/paratiriseis-proiontos",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title:
          "Ερώτηση σχετικά με τον ιστότοπο και την προσβασιμότητα στον ιστό",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_gr,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/epikoinonia/erotisi-istoselida-web",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "ro",
      code: "ro",
      default: true,
    },
    forms: [
      {
        title: "FORM.PRODUCT_INFORMATION_TITLE",
        iconName: "mystery-can",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                autocomplete: "family-name",
                width: 50,
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                autocomplete: "given-name",
                width: 50,
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                autocomplete: "email",
                width: 100,
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: false,
                width: 50,
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                autocomplete: "address-line2",
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: false,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ro,
                technicalName: "Country",
                autocomplete: "off",
                required: false,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                required: false,
                type: "number",
                validators: "min(13), max(13)",
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "  ",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                required: false,
                autocomplete: "off",
                error: "FORM.EXPIRED_DATE_ERROR",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contact/informatii-despre-produs",
        },
        seoTitle: "FORM.PRODUCT_INFORMATION.SEO_TITLE",
        seoDescription: "FORM.PRODUCT_INFORMATION.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Information",
          CS_UserChannel: "API_BEL_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Information",
          CS_UserChannel: "API_FRESH_Produit_Information",
          Category: "7",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "FORM.PRODUCT.NOTE.TITLE",
        iconName: "bell",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                required: true,
                width: 50,
                autocomplete: "address-line1",
              },
              {
                label: "FORM.ADDRESS_COMPLEMENT",
                placeholder: "FORM.ADDRESS_COMP_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address2",
                required: false,
                width: 50,
                autocomplete: "address-line2",
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                width: 50,
                autocomplete: "tel",
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ro,
                technicalName: "Country",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS",
            description: "FORM.PRODUCT_INFORMATION_DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_RANGE",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: [
                  {
                    label: "FORM.CATEGORY.FROZEN",
                    value: "3",
                  },
                  {
                    label: "FORM.CATEGORY.CAN",
                    value: "1",
                  },
                ],
                technicalName: "CS_Technology",
                required: true,
                autocomplete: "off",
                width: 50,
              },
              {
                label: "FORM.PRODUCT_NAME",
                placeholder: "",
                description: "FORM.PRODUCT_NAME_PLH",
                sfType: "SfFormTextField",
                technicalName: "CS_MarketingDescription",
                required: true,
                autocomplete: "off",
                width: 50,
              },
            ],
          },
          {
            title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
            description: "FORM.PRODUCT.DETAIL.DESC",
            formFields: [
              {
                label: "FORM.PRODUCT_INFORMATIONS_LABEL",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_UCEANCode",
                type: "number",
                validators: "min(13), max(13)",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
                //   image: "/assets/images/barcode.png",
                // },
              },
              {
                label: "FORM.PRODUCT_LOT",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_BatchNumber",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.PRODUCT_LOT_INFO",
                // },
              },
              {
                label: "FORM.EXPIRED_DATE",
                placeholder: "",
                description: "",
                sfType: "SfFormTextField",
                technicalName: "CS_DLUODLC",
                error: "FORM.EXPIRED_DATE_ERROR",
                required: false,
                autocomplete: "off",
                width: 50,
                // hint: {
                //   description: "FORM.EXPIRED_DATE_DESC",
                // },
                type: "date",
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contact/opinia-ta-despre-produs",
        },
        seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
        seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_Produit_Reclamation",
          CS_UserChannel: "API_BEL_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_Produit_Reclamation",
          CS_UserChannel: "API_FRESH_Produit_Reclamation",
          Category: "6",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
      {
        title: "Întrebare despre site-ul web și accesibilitatea web",
        iconName: "desktop",
        formSections: [
          {
            title: "FORM.INFORMATIONS",
            description: "",
            formFields: [
              {
                label: "FORM.NAME",
                placeholder: "FORM.OUR_NAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "LastName",
                required: true,
                width: 50,
                autocomplete: "family-name",
              },
              {
                label: "FORM.FIRSTNAME",
                placeholder: "FORM.OUR_FIRSTNAME",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "FirstName",
                required: true,
                width: 50,
                autocomplete: "given-name",
              },
              {
                label: "FORM.MAIL",
                placeholder: "FORM.MAIL_PLH",
                description: "",
                confirm: "FORM.MAIL_CONFIRM",
                sfType: "SfFormTextFieldConfirm",
                style: "underline",
                technicalName: "EMail",
                validators: ["email"],
                error: "FORM.MAIL_ERROR",
                errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
                required: true,
                width: 100,
                autocomplete: "email",
              },
              {
                label: "FORM.ADDRESS",
                placeholder: "FORM.STREET",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "Address1",
                autocomplete: "address-line1",
                required: true,
                width: 50,
              },
              {
                label: "FORM.ZIPCODE",
                placeholder: "FORM.ZIPCODE",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                validationRegex: "",
                technicalName: "ZipCode",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.CITY",
                placeholder: "FORM.CITY_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "City",
                required: true,
                autocomplete: "off",
                width: 25,
              },
              {
                label: "FORM.PHONE",
                placeholder: "FORM.PHONE_PLH",
                description: "",
                sfType: "SfFormTextField",
                style: "underline",
                technicalName: "DirectLine",
                validators: ["phone"],
                required: true,
                autocomplete: "tel",
                width: 50,
              },
              {
                label: "FORM.COUNTRY",
                placeholder: "",
                description: "",
                sfType: "SfFormSelect",
                default: "",
                values: countries_ro,
                technicalName: "Country",
                autocomplete: "off",
                required: true,
                width: 50,
              },
            ],
          },
          {
            title: "FORM.MESSAGE",
            description: "",
            formFields: [
              {
                label: "",
                placeholder: "FORM.OUR_MESSAGE",
                description: "",
                sfType: "SfFormTextArea",
                style: "underline",
                technicalName: "Request",
                required: true,
                autocomplete: "off",
                width: 100,
              },
            ],
          },
        ],
        link: {
          url: "/contact/intrebare-site-web",
        },
        seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
        seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
        channelBellInfo: {
          Channel: "API_BEL_eCommerce_NavSite",
          CS_UserChannel: "API_BEL_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "1",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
        channelFreshInfo: {
          Channel: "API_FRESH_eCommerce_NavSite",
          CS_UserChannel: "API_FRESH_eCommerce_NavSite",
          Category: "42",
          CS_SalesNetwork: "1",
          CS_Technology: "2",
          CS_Brand: "3",
          CS_PurchaseCountry: "2",
          CS_autoAffectationWS: "1",
        },
      },
    ],
    content: [],
  },
  {
    lang: {
      country: "br",
      code: "pt",
      default: true,
    },
    forms: [
      // {
      //   title: "FORM.PRODUCT.NOTE.TITLE",
      //   iconName: "bell",
      //   formSections: [
      //     {
      //       title: "FORM.INFORMATIONS",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "FORM.NAME",
      //           placeholder: "FORM.OUR_NAME",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "LastName",
      //           required: true,
      //           width: 50,
      //           autocomplete: "family-name",
      //         },
      //         {
      //           label: "FORM.FIRSTNAME",
      //           placeholder: "FORM.OUR_FIRSTNAME",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "FirstName",
      //           required: true,
      //           width: 50,
      //           autocomplete: "given-name",
      //         },
      //         {
      //           label: "FORM.MAIL",
      //           placeholder: "FORM.MAIL_PLH",
      //           description: "",
      //           confirm: "FORM.MAIL_CONFIRM",
      //           sfType: "SfFormTextFieldConfirm",
      //           style: "underline",
      //           technicalName: "EMail",
      //           validators: ["email"],
      //           error: "FORM.MAIL_ERROR",
      //           errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
      //           required: true,
      //           width: 100,
      //           autocomplete: "email",
      //         },
      //         {
      //           label: "FORM.ADDRESS",
      //           placeholder: "FORM.STREET",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "Address1",
      //           required: true,
      //           width: 50,
      //           autocomplete: "address-line1",
      //         },
      //         {
      //           label: "FORM.ADDRESS_COMPLEMENT",
      //           placeholder: "FORM.ADDRESS_COMP_PLH",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "Address2",
      //           required: false,
      //           width: 50,
      //           autocomplete: "address-line2",
      //         },
      //         {
      //           label: "FORM.ZIPCODE",
      //           placeholder: "FORM.ZIPCODE",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           validationRegex: "",
      //           technicalName: "ZipCode",
      //           required: true,
      //           autocomplete: "off",
      //           width: 25,
      //         },
      //         {
      //           label: "FORM.CITY",
      //           placeholder: "FORM.CITY_PLH",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "City",
      //           required: true,
      //           autocomplete: "off",
      //           width: 25,
      //         },
      //         {
      //           label: "FORM.PHONE",
      //           placeholder: "FORM.PHONE_PLH",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "DirectLine",
      //           validators: ["phone"],
      //           required: true,
      //           width: 50,
      //           autocomplete: "tel",
      //         },
      //         {
      //           label: "FORM.COUNTRY",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormSelect",
      //           default: "",
      //           values: countries_br,
      //           technicalName: "Country",
      //           required: true,
      //           autocomplete: "off",
      //           width: 50,
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.PRODUCT_INFORMATIONS",
      //       description: "FORM.PRODUCT_INFORMATION_DESC",
      //       formFields: [
      //         {
      //           label: "FORM.PRODUCT_RANGE",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormSelect",
      //           default: "",
      //           values: [
      //             {
      //               label: "FORM.CATEGORY.SALAD",
      //               value: "2",
      //             },
      //             {
      //               label: "FORM.CATEGORY.FROZEN",
      //               value: "3",
      //             },
      //             {
      //               label: "FORM.CATEGORY.CAN",
      //               value: "1",
      //             },
      //             {
      //               label: "FORM.CATEGORY.TAKEAWAY",
      //               value: "4",
      //             },
      //           ],
      //           technicalName: "CS_Technology",
      //           required: true,
      //           autocomplete: "off",
      //           width: 50,
      //         },
      //         {
      //           label: "FORM.PRODUCT_NAME",
      //           placeholder: "",
      //           description: "FORM.PRODUCT_NAME_PLH",
      //           sfType: "SfFormTextField",
      //           technicalName: "CS_MarketingDescription",
      //           required: true,
      //           autocomplete: "off",
      //           width: 50,
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.PRODUCT_INFORMATIONS_DETAIL",
      //       description: "FORM.PRODUCT.DETAIL.DESC",
      //       formFields: [
      //         {
      //           label: "FORM.PRODUCT_INFORMATIONS_LABEL",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           technicalName: "CS_UCEANCode",
      //           type: "number",
      //           validators: "min(13), max(13)",
      //           required: true,
      //           autocomplete: "off",
      //           width: 50,
      //           // hint: {
      //           //   description: "FORM.PRODUCT_INFORMATIONS_PLH",
      //           //   image: "/assets/images/barcode.png",
      //           // },
      //         },
      //         {
      //           label: "FORM.PRODUCT_LOT",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           technicalName: "CS_BatchNumber",
      //           required: true,
      //           autocomplete: "off",
      //           width: 50,
      //           // hint: {
      //           //   description: "FORM.PRODUCT_LOT_INFO",
      //           // },
      //         },
      //         {
      //           description: "",
      //           sfType: "SfFormImage",
      //           technicalName: "",
      //           required: false,
      //           autocomplete: "off",
      //           width: 50,
      //         },
      //         {
      //           description: "",
      //           sfType: "SfFormImage",
      //           technicalName: "",
      //           required: false,
      //           autocomplete: "off",
      //           width: 50,
      //         },
      //         {
      //           label: "FORM.EXPIRED_DATE",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           technicalName: "CS_DLUODLC",
      //           error: "FORM.EXPIRED_DATE_ERROR",
      //           required: false,
      //           autocomplete: "off",
      //           width: 50,
      //           hint: {
      //             description: "FORM.EXPIRED_DATE_DESC",
      //           },
      //           type: "date",
      //         },
      //         {
      //           description: "",
      //           sfType: "SfFormImage",
      //           technicalName: "",
      //           required: false,
      //           autocomplete: "off",
      //           width: 50,
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.MESSAGE",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "",
      //           placeholder: "FORM.OUR_MESSAGE",
      //           description: "",
      //           sfType: "SfFormTextArea",
      //           style: "underline",
      //           technicalName: "Request",
      //           required: true,
      //           autocomplete: "off",
      //           width: 100,
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.PHOTO_MORE",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormImageMulti",
      //           technicalName: "",
      //           required: false,
      //           autocomplete: "off",
      //           width: 100,
      //         },
      //       ],
      //     },
      //   ],
      //   link: {
      //     url: "/contato/comentario-produto",
      //   },
      //   seoTitle: "FORM.PRODUCT.NOTE.SEO_TITLE",
      //   seoDescription: "FORM.PRODUCT.NOTE.SEO_DESC",
      //   channelBellInfo: {
      //     Channel: "API_BEL_Produit_Reclamation",
      //     CS_UserChannel: "API_BEL_Produit_Reclamation",
      //     Category: "6",
      //     CS_SalesNetwork: "1",
      //     CS_Technology: "1",
      //     CS_Brand: "3",
      //     CS_PurchaseCountry: "2",
      //     CS_autoAffectationWS: "1",
      //   },
      //   channelFreshInfo: {
      //     Channel: "API_FRESH_Produit_Reclamation",
      //     CS_UserChannel: "API_FRESH_Produit_Reclamation",
      //     Category: "6",
      //     CS_SalesNetwork: "1",
      //     CS_Technology: "2",
      //     CS_Brand: "3",
      //     CS_PurchaseCountry: "2",
      //     CS_autoAffectationWS: "1",
      //   },
      // },
      // {
      //   title: "FORM.FOOD_SERVICE",
      //   iconName: "chef",
      //   formSections: [],
      //   link: {
      //     url: "https://www.bonduelle-foodservice.br/contato",
      //     is_external: true,
      //   },
      // },
      // {
      //   title: "FORM.WEB_SUGGESTION.TITLE",
      //   iconName: "desktop",
      //   formSections: [
      //     {
      //       title: "FORM.INFORMATIONS",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "FORM.NAME",
      //           placeholder: "FORM.OUR_NAME",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "LastName",
      //           required: true,
      //           width: 50,
      //           autocomplete: "family-name",
      //         },
      //         {
      //           label: "FORM.FIRSTNAME",
      //           placeholder: "FORM.OUR_FIRSTNAME",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "FirstName",
      //           required: true,
      //           width: 50,
      //           autocomplete: "given-name",
      //         },
      //         {
      //           label: "FORM.MAIL",
      //           placeholder: "FORM.MAIL_PLH",
      //           description: "",
      //           confirm: "FORM.MAIL_CONFIRM",
      //           sfType: "SfFormTextFieldConfirm",
      //           style: "underline",
      //           technicalName: "EMail",
      //           validators: ["email"],
      //           error: "FORM.MAIL_ERROR",
      //           errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
      //           required: true,
      //           width: 100,
      //           autocomplete: "email",
      //         },
      //         {
      //           label: "FORM.PHONE",
      //           placeholder: "FORM.PHONE_PLH",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "DirectLine",
      //           validators: ["phone"],
      //           required: false,
      //           width: 50,
      //           autocomplete: "tel",
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.MESSAGE",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "",
      //           placeholder: "FORM.OUR_MESSAGE",
      //           description: "",
      //           sfType: "SfFormTextArea",
      //           style: "underline",
      //           technicalName: "Request",
      //           required: true,
      //           autocomplete: "off",
      //           width: 100,
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.PHOTO_MORE",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormImageMulti",
      //           technicalName: "",
      //           required: false,
      //           autocomplete: "off",
      //           width: 100,
      //         },
      //       ],
      //     },
      //   ],
      //   link: {
      //     url: "/contato/sugestao",
      //   },
      //   seoTitle: "FORM.WEB_SUGGESTION.SEO_TITLE",
      //   seoDescription: "FORM.WEB_SUGGESTION.SEO_DESC",
      //   channelBellInfo: {
      //     Channel: "API_BEL_eCommerce_NavSite",
      //     CS_UserChannel: "API_BEL_eCommerce_NavSite",
      //     Category: "42",
      //     CS_SalesNetwork: "1",
      //     CS_Technology: "1",
      //     CS_Brand: "3",
      //     CS_PurchaseCountry: "2",
      //     CS_autoAffectationWS: "1",
      //   },
      //   channelFreshInfo: {
      //     Channel: "API_FRESH_eCommerce_NavSite",
      //     CS_UserChannel: "API_FRESH_eCommerce_NavSite",
      //     Category: "42",
      //     CS_SalesNetwork: "1",
      //     CS_Technology: "2",
      //     CS_Brand: "3",
      //     CS_PurchaseCountry: "2",
      //     CS_autoAffectationWS: "1",
      //   },
      // },
      // {
      //   title: "FORM.ANOTHER.TITLE",
      //   iconName: "question-bubble",
      //   formSections: [
      //     {
      //       title: "FORM.INFORMATIONS",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "FORM.NAME",
      //           placeholder: "FORM.OUR_NAME",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "LastName",
      //           required: true,
      //           width: 50,
      //           autocomplete: "family-name",
      //         },
      //         {
      //           label: "FORM.FIRSTNAME",
      //           placeholder: "FORM.OUR_FIRSTNAME",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "FirstName",
      //           required: true,
      //           width: 50,
      //           autocomplete: "given-name",
      //         },
      //         {
      //           label: "FORM.MAIL",
      //           placeholder: "FORM.MAIL_PLH",
      //           description: "",
      //           confirm: "FORM.MAIL_CONFIRM",
      //           sfType: "SfFormTextFieldConfirm",
      //           style: "underline",
      //           technicalName: "EMail",
      //           validators: ["email"],
      //           error: "FORM.MAIL_ERROR",
      //           errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
      //           required: true,
      //           width: 100,
      //           autocomplete: "email",
      //         },
      //         {
      //           label: "FORM.PHONE",
      //           placeholder: "FORM.PHONE_PLH",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "DirectLine",
      //           validators: ["phone"],
      //           required: false,
      //           width: 50,
      //           autocomplete: "tel",
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.MESSAGE",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "",
      //           placeholder: "FORM.OUR_MESSAGE",
      //           description: "",
      //           sfType: "SfFormTextArea",
      //           style: "underline",
      //           technicalName: "Request",
      //           required: true,
      //           autocomplete: "off",
      //           width: 100,
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.PHOTO_MORE",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormImageMulti",
      //           technicalName: "",
      //           required: false,
      //           autocomplete: "off",
      //           width: 100,
      //         },
      //       ],
      //     },
      //   ],
      //   link: {
      //     url: "/contato/outro-pedido",
      //   },
      //   seoTitle: "FORM.ANOTHER.SEO_TITLE",
      //   seoDescription: "FORM.ANOTHER/SEO_DESC",
      //   channelBellInfo: {
      //     Channel: "API_BEL_Produit_Information",
      //     CS_UserChannel: "API_BEL_Produit_Information",
      //     Category: "7",
      //     CS_SalesNetwork: "1",
      //     CS_Technology: "1",
      //     CS_Brand: "3",
      //     CS_PurchaseCountry: "2",
      //     CS_autoAffectationWS: "1",
      //   },
      //   channelFreshInfo: {
      //     Channel: "API_FRESH_Produit_Information",
      //     CS_UserChannel: "API_FRESH_Produit_Information",
      //     Category: "7",
      //     CS_SalesNetwork: "1",
      //     CS_Technology: "2",
      //     CS_Brand: "3",
      //     CS_PurchaseCountry: "2",
      //     CS_autoAffectationWS: "1",
      //   },
      // },
      // {
      //   title: "Pergunta sobre o site e a acessibilidade web",
      //   iconName: "desktop",
      //   formSections: [
      //     {
      //       title: "FORM.INFORMATIONS",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "FORM.NAME",
      //           placeholder: "FORM.OUR_NAME",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "LastName",
      //           required: true,
      //           width: 50,
      //           autocomplete: "family-name",
      //         },
      //         {
      //           label: "FORM.FIRSTNAME",
      //           placeholder: "FORM.OUR_FIRSTNAME",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "FirstName",
      //           required: true,
      //           width: 50,
      //           autocomplete: "given-name",
      //         },
      //         {
      //           label: "FORM.MAIL",
      //           placeholder: "FORM.MAIL_PLH",
      //           description: "",
      //           confirm: "FORM.MAIL_CONFIRM",
      //           sfType: "SfFormTextFieldConfirm",
      //           style: "underline",
      //           technicalName: "EMail",
      //           validators: ["email"],
      //           error: "FORM.MAIL_ERROR",
      //           errorConfirm: "FORM.MAIL_ERROR_CONFIRM",
      //           required: true,
      //           width: 100,
      //           autocomplete: "email",
      //         },
      //         {
      //           label: "FORM.ADDRESS",
      //           placeholder: "FORM.STREET",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "Address1",
      //           autocomplete: "address-line1",
      //           required: true,
      //           width: 50,
      //         },
      //         {
      //           label: "FORM.ZIPCODE",
      //           placeholder: "FORM.ZIPCODE",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           validationRegex: "",
      //           technicalName: "ZipCode",
      //           required: true,
      //           autocomplete: "off",
      //           width: 25,
      //         },
      //         {
      //           label: "FORM.CITY",
      //           placeholder: "FORM.CITY_PLH",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "City",
      //           required: true,
      //           autocomplete: "off",
      //           width: 25,
      //         },
      //         {
      //           label: "FORM.PHONE",
      //           placeholder: "FORM.PHONE_PLH",
      //           description: "",
      //           sfType: "SfFormTextField",
      //           style: "underline",
      //           technicalName: "DirectLine",
      //           validators: ["phone"],
      //           required: true,
      //           autocomplete: "tel",
      //           width: 50,
      //         },
      //         {
      //           label: "FORM.COUNTRY",
      //           placeholder: "",
      //           description: "",
      //           sfType: "SfFormSelect",
      //           default: "",
      //           values: countries_br,
      //           technicalName: "Country",
      //           autocomplete: "off",
      //           required: true,
      //           width: 50,
      //         },
      //       ],
      //     },
      //     {
      //       title: "FORM.MESSAGE",
      //       description: "",
      //       formFields: [
      //         {
      //           label: "",
      //           placeholder: "FORM.OUR_MESSAGE",
      //           description: "",
      //           sfType: "SfFormTextArea",
      //           style: "underline",
      //           technicalName: "Request",
      //           required: true,
      //           autocomplete: "off",
      //           width: 100,
      //         },
      //       ],
      //     },
      //   ],
      //   link: {
      //     url: "/contato/pergunta-site-web",
      //   },
      //   seoTitle: "FORM.ACCESSIBILITY.SEO_TITLE",
      //   seoDescription: "FORM.ACCESSIBILITY.SEO_DESC",
      //   channelBellInfo: {
      //     Channel: "API_BEL_eCommerce_NavSite",
      //     CS_UserChannel: "API_BEL_eCommerce_NavSite",
      //     Category: "42",
      //     CS_SalesNetwork: "1",
      //     CS_Technology: "1",
      //     CS_Brand: "3",
      //     CS_PurchaseCountry: "2",
      //     CS_autoAffectationWS: "1",
      //   },
      //   channelFreshInfo: {
      //     Channel: "API_FRESH_eCommerce_NavSite",
      //     CS_UserChannel: "API_FRESH_eCommerce_NavSite",
      //     Category: "42",
      //     CS_SalesNetwork: "1",
      //     CS_Technology: "2",
      //     CS_Brand: "3",
      //     CS_PurchaseCountry: "2",
      //     CS_autoAffectationWS: "1",
      //   },
      // },
    ],
    content: [],
  },
];
